import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ActivityType } from '@omni/classes/activity/activity.class';
import { EventActivity } from '@omni/classes/events-tool/event.class';
import { IONote } from "@omni/classes/io/io-note.class";
import { Currency, MarketingPlan } from '@omni/classes/marketing-management/marketing-plan.class';
import { Opportunity } from '@omni/classes/opportunity-management/opportunity.class';
import { AccountPageComponent } from '@omni/components/account/account-page/account-page';
import { ContactPageComponent } from '@omni/components/contact/contact-page/contact-page';
import { EventsToolPageComponent } from '@omni/components/events-tool/event-tool-page/events-tools-page';
import { OpportunitySelectionPageComponent } from '@omni/components/opportunity-management/opportunity-selection-master-page/opportunity-selection-master-page';
import { CurViewPageType, DateTimeFieldType, IndDatetimeFormComponent } from '@omni/components/shared/ind-datetime-form/ind-datetime-form';
import { IndDropdownListComponent } from '@omni/components/shared/ind-dropdown-list/ind-dropdown-list';
import { SelectListComponent } from '@omni/components/shared/select-list/select-list';
import { MarketingPlanManagementDataService } from '@omni/data-services/marketing-plan/marketing-plan-management.data.service';
import { SurgeryOrderActivityDataService } from '@omni/data-services/surgery-order-activity/surgery-order-activity.data.service';
import { EventsSelectionViewDataModel } from '@omni/models/events-selection-page-model';
import { IndDateTimeFormViewDataModel } from '@omni/models/indDateTimeFormDataModel';
import { IndDropdownListDetailModel } from '@omni/models/indDropdownListModel';
import { IndPageTitleViewDataModel } from '@omni/models/indPageTitleDataModel';
import { OpportunitySelectionViewDataModel } from '@omni/models/opportunities-selection-page-model';
import { SelectListData } from '@omni/models/select-list-data-model';
import { AccountOfflineService } from '@omni/services/account/account.offline.service';
import { BrandOfflineService } from '@omni/services/brand/brand.service';
import { ContactOfflineService } from '@omni/services/contact/contact.service';
import { EventsToolService } from '@omni/services/events-tool/events-tool.service';
import { EventName, EventsService } from '@omni/services/events/events.service';
import { FooterService, FooterViews } from '@omni/services/footer/footer.service';
import { GlobalUtilityService } from '@omni/services/global-utility.service';
import { MarketingPlansManagementOfflineService } from '@omni/services/marketing-management/marketing-management.service';
import { NotificationService, ToastStyle } from '@omni/services/notification/notification.service';
import { MAXIMUM_NOTE_ATTACHMENT_SIZE, NOTE_ATTACHMENT_MIME_TYPES_SUPPORTED_REGEX, toBase64 } from '@omni/utility/util';
import { isBefore, isPast, isValid } from 'date-fns';
import * as _ from 'lodash';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Guid } from 'typescript-guid';
import { FollowUpActivity } from '../../../classes/activity/follow-up-action.activity.class';
import { FeatureActionsMap } from '../../../classes/authentication/user.class';
import { FormFieldType, IndFormFieldViewDataModel } from '../../../models/indFormFieldDataModel';
import { IndSectionHeaderViewDataModel } from '../../../models/indSectionHeaderDataModel';
import { MainCardViewDataModel } from '../../../models/MainCardViewDataModel';
import { ActivityService } from '../../../services/activity/activity.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { DateTimeFormatsService } from '../../../services/date-time-formats/date-time-formats.service';
import { DeviceService } from '../../../services/device/device.service';
import { NavigationService, PageName } from '../../../services/navigation/navigation.service';
import { OpportunityManagementService } from '../../../services/opportunity-management/opportunity-management.service';
import { ComponentViewMode, UIService } from '../../../services/ui/ui.service';

@Component({
  selector: 'marketing-plan-info',
  templateUrl: 'marketing-plan-info.html',
  styleUrls: ['marketing-plan-info.scss']
})
export class MarketingPlanInfo implements OnInit, OnDestroy {
  @Input() data: MarketingPlan;
  @ViewChild('attachInput') attachInput: ElementRef;
  private isOpportunitiesEnabled = false;
  //calling it a reference as its a copy by reference and not by value
  public planDataSetReference: MarketingPlan;
  public allModelObjectives: Array<MainCardViewDataModel> = [];
  public expensesMainCardModel: Array<MainCardViewDataModel> = [];
  public checkIfInvalidDocuments = false;
  // formattedPeriod: string;
  productsString: string;
  followUpTasksForPlan: FollowUpActivity[];
  ngUnSubscibe$ = new Subject<boolean>();
  showMore = false;
  strategy_Text_default_length = 150;
  private contactsString: string;
  public pageTitle: IndPageTitleViewDataModel;
  public detailHeaderModel: IndSectionHeaderViewDataModel;
  public notesHeaderModel: IndSectionHeaderViewDataModel;
  private isSaveNotesEnabled: boolean = false;
  public notes: string;
  private attachmentFile: any;
  private base64str: any;
  public isAttachmentAdded: boolean = false;
  public attachmentTitle: string = '';
  public eventsSectionHeaderModel: IndSectionHeaderViewDataModel;
  public associatedEvents: EventActivity[] = [];
  public associatedOpportunities: Opportunity[] = [];
  public deviceOffline: boolean = false;
  private isEventsEnabled = false;
  public accountsString: string;
  private _isClicked: { [x: string]: boolean } = {};
  public opportunitiesSectionHeaderModel: IndSectionHeaderViewDataModel;
  public brandnotes: any;
  public isReadOnlyMode = false;
  public isAutoNameEnabled = false;
  applicableOpportunities: Opportunity[];

  constructor(
    public device: DeviceService,
    public activityService: ActivityService,
    public authService: AuthenticationService,
    public dateTimeFormatsService: DateTimeFormatsService,
    public opportunityService: OpportunityManagementService,
    public footerService: FooterService,
    public uiService: UIService,
    private datePipe: DatePipe,
    private utilityService: GlobalUtilityService,
    private contactService: ContactOfflineService,
    private events: EventsService,
    public readonly translate: TranslateService,
    private readonly popoverCtrl: PopoverController,
    private readonly navService: NavigationService,
    private accountService: AccountOfflineService,
    private notificationService: NotificationService,
    public marketingPlansManagementOfflineService: MarketingPlansManagementOfflineService,
    public marketingPlanManagementDataService: MarketingPlanManagementDataService,
    private readonly brandService: BrandOfflineService,
    private modalCtrl: ModalController,
    private eventToolService: EventsToolService,
    private surgeryOrderActivityDataService: SurgeryOrderActivityDataService
  ) { }

  ngOnInit() {
    this.isOpportunitiesEnabled = this.authService.hasFeatureAction(FeatureActionsMap.OPPORTUNITY_MANAGEMENT);
    this.isEventsEnabled = this.authService.hasFeatureAction(FeatureActionsMap.EVENTS_IN_ACCOUNT_PLAN);

    this.marketingPlansManagementOfflineService.selectedMarketingPlan$.pipe(takeUntil(this.ngUnSubscibe$)).subscribe((selectedMarketingPlan) => {
      if (selectedMarketingPlan) {
        this.planDataSetReference = _.cloneDeep(this.marketingPlansManagementOfflineService.marketingPlans.find(({ ID }) => ID === selectedMarketingPlan.ID));
        if (this.planDataSetReference) {
          let endDate = new Date(parseInt(this.planDataSetReference.endDate))
          this.isReadOnlyMode = this.navService.getPreviousPageName() === PageName.OpportunityManagementPage || this.authService.user.systemUserID !== this.planDataSetReference.ownerID || this.device.isOffline || isPast(endDate);
          this.setViewdata();
          this.initializeHeaders();
          let marketPlanAutoName = this.generateMarketPlanName(this.planDataSetReference.accounts, this.planDataSetReference.products);
          this.isAutoNameEnabled = marketPlanAutoName === this.planDataSetReference.brandPlanName || this.planDataSetReference.brandPlanName === this.translate.instant('MARKETING_BUSINESS_PLAN');
        }
      }
    });

    this.device.isOfflineObservable.pipe(takeUntil(this.ngUnSubscibe$)).subscribe(isOffline => {
      // if the device offlice diisable events add button and account plan cancel button
      this.deviceOffline = isOffline;
      this.initializeHeaders();
    });

    if (this.navService.getCurrentMasterPageName() == PageName.ActivitiesPageComponent && this.uiService.activitiesPagePlanTabSelectedPlan === 'goalsPlansTab') {
      this.footerService.initButtons(FooterViews.AccountPlanObjectives);
    }
    this.initializeHeaders();
  }

  private initializeHeaders() {
    this.initializeAPDetailHeader();
    this.initializeEventsHeader();
    this.initializeNotesHeader();
    this.initializeopportunitiesHeader()
  }

  private initializeAPDetailHeader() {
    this.detailHeaderModel = {
      id: 'account-plan-detail-header',
      title: this.translate.instant('DETAILS_CAP'),
      controls: [],
    };
  }

  private initializeEventsHeader() {
    const planExpiredOrCompleted = this.planDataSetReference.status === 'Completed';
    this.eventsSectionHeaderModel = {
      id: 'account-plan-events-header',
      title: this.translate.instant('EVENTS'),
      controls: [{
        id: 'add-marketing-plan-events',
        text: this.translate.instant('ADD'),
        isDisabled: this.navService.getPreviousPageName() === PageName.OpportunityManagementPage || this.deviceOffline || isPast(parseInt(this.planDataSetReference.endDate)),
        isVisible: this.isEventsEnabled
      }]
    };
  }

  private initializeopportunitiesHeader() {
    this.opportunitiesSectionHeaderModel = {
      id: 'opportunities',
      title: this.translate.instant('OPPORTUNITIES'),
      controls: [
        {
          id: 'add-opportunities',
          text: this.translate.instant('ADD'),
          isDisabled: this.navService.getPreviousPageName() === PageName.OpportunityManagementPage || this.deviceOffline || isPast(parseInt(this.planDataSetReference.endDate)),
          isVisible: this.isOpportunitiesEnabled
        }
      ]
    };
  }

  private initializeNotesHeader() {
    let controls = [
      {
        id: "attach",
        text: this.translate.instant('ATTACH'),
        isDisabled: this.device.isOffline || this.isReadOnlyMode,
        // isVisible: !this.isReadOnlyMode,
      },
      {
        id: 'save-notes',
        text: this.translate.instant('SAVE'),
        isDisabled: !this.isSaveNotesEnabled || this.isReadOnlyMode,
        // isVisible: !this.isReadOnlyMode,
      }
    ]
    this.notesHeaderModel = {
      id: 'notes-header',
      title: this.translate.instant('NOTES'),
      controls: controls
    }
  }

  private get startPeriod() {
    return this._getFormattedDate(this.planDataSetReference.startDate);
  }

  private get endPeriod() {
    return this._getFormattedDate(this.planDataSetReference.endDate);
  }

  private _getFormattedDate(value: any) {
    return this.datePipe.transform(value, this.dateTimeFormatsService.date, undefined, this.translate.currentLang);
  }

  setViewdata(data?: MarketingPlan) {
    this.getStartPeriodFormField();
    this.getEndPeriodFormField();
    this.productsString = this.getProductsString;
    this.contactsString = this.getContactString;
    this.accountsString = this.getAccountsString;
    this.associatedEvents = this.planDataSetReference.events ? _.orderBy(this.planDataSetReference.events.filter(event => event.statuscode !== 548910006), "name") : [];
    this.associatedOpportunities = _.orderBy(this.planDataSetReference.opportunities, "opportunityName");
    this.brandnotes = this.planDataSetReference.MarketingPlansNotes.sort((a, b) => {
      return (isBefore(a.createdTime, b.createdTime) ? 1 : -1)
    })
  }

  private get getContactString() {
    let numberOfContacts = this.planDataSetReference.contacts.length;
    if (numberOfContacts === 0) return '';
    return this.planDataSetReference.contacts[0].contactFullName + (numberOfContacts > 1 ? ` +${numberOfContacts - 1}` : '');
  }

  private get getProductsString() {
    let numberOfProducts = this.planDataSetReference.products.length;
    if (numberOfProducts === 0) return '';
    return this.planDataSetReference.products[0].productName + (numberOfProducts > 1 ? ` +${numberOfProducts - 1}` : '');
  }

  private get getAccountsString() {
    let numberOfAccounts = this.planDataSetReference.accounts.length;
    if (numberOfAccounts === 0) return '';
    return this.planDataSetReference.accounts[0].name + (numberOfAccounts > 1 ? ` +${numberOfAccounts - 1}` : '');
  }

  public getFormattedDueDate(value): string {
    if (isValid(value)) {
      return `${this.translate.instant('DUE')} ${this._getFormattedDate(value)}`;
    } else {
      return '';
    }
  }

  public backToAccountPlanList(): void {
    if (this.uiService.activitiesPagePlanTabSelectedPlan == 'accountPlansTab') {
      this.navService.popToRootWithPageTracking();
    }
    this.navService.popChildNavPageWithPageTracking();
    this.uiService.showRightPane = false;
    // this.accountManagementService.isRightPaneNavActive = false;
  }

  public getProductFormField(): IndFormFieldViewDataModel {
    let viewData: IndFormFieldViewDataModel;
    viewData = {
      label: this.translate.instant('PRODUCTS'),
      inputText: this.productsString,
      customPlaceholderLabel: !this.isReadOnlyMode ? this.translate.instant('SELECT_PRODUCTS') : `${this.translate.instant('NO')} ${this.translate.instant('PRODUCTS')}`,
      id: 'products-field',
      formFieldType: FormFieldType.NEW_PAGE_SELECT,
      isReadOnly: true,
      isDisabled: _.isEmpty(this.planDataSetReference.products) && this.isReadOnlyMode,
      showArrow: !this.isReadOnlyMode,
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    };
    return viewData;
  }

  public getNameFormField(): IndFormFieldViewDataModel {
    let viewData: IndFormFieldViewDataModel;
    viewData = {
      label: this.translate.instant('NAME'),
      inputText: this.planDataSetReference?.brandPlanName,
      inputValue: this.planDataSetReference?.brandPlanName,
      id: 'name-field',
      isDisabled: this.isReadOnlyMode,
      placeholderLabel: this.translate.instant('NAME'),
      showArrow: !this.isReadOnlyMode,
      formFieldType: FormFieldType.INLINE_INPUT,
      isRequired: true,
      errorMessage: this.translate.instant('THIS_IS_A_REQUIRED_FIELD'),
      isEmptyRequiredField: this._isClicked && this._isClicked['name-field'] && _.isEmpty(this.planDataSetReference.brandPlanName),
      eventHandler: (id: string, event, eventName) => {
        this.handleFormFieldEvent(id, event, eventName);
        this._isClicked['name-field'] = true;
      }
    };
    return viewData;
  }

  public getAccountsFormField(): IndFormFieldViewDataModel {
    let viewData: IndFormFieldViewDataModel;
    viewData = {
      label: this.translate.instant('ACCOUNTS'),
      inputText: this.accountsString,
      inputValue: this.accountsString,
      customPlaceholderLabel: this.isReadOnlyMode ? this.translate.instant('NO_ACCOUNTS') : this.translate.instant('SELECT_ACCOUNTS'),
      id: 'account-field',
      isReadOnly: true,
      isDisabled: _.isEmpty(this.planDataSetReference.accounts) && this.isReadOnlyMode,
      formFieldType: FormFieldType.NEW_PAGE_SELECT,
      showArrow: !this.isReadOnlyMode,
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    };
    return viewData;
  }

  public getCurrencyFormField() {
    const viewData: IndFormFieldViewDataModel = {
      label: this.translate.instant('CURRENCY'),
      inputText: this.planDataSetReference ? this.planDataSetReference?.currencyName : "",
      customPlaceholderLabel: !this.isReadOnlyMode ? this.translate.instant('SELECT_CURRENCY') : this.translate.instant('NO') + " " + this.translate.instant('CURRENCY'),
      id: 'currency',
      isReadOnly: true,
      isDisabled: this.isReadOnlyMode,
      showArrow: !this.isReadOnlyMode,
      formFieldType: FormFieldType.POPOVER_SELECT,
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    }
    return viewData;
  }

  public getBudgetFormField() {
    const isDisabled = this.isReadOnlyMode || this.planDataSetReference?.status === 'Completed' || !this.planDataSetReference?.currencyId;
    const viewData: IndFormFieldViewDataModel = {
      label: this.translate.instant('BUDGET'),
      inputText: this.planDataSetReference?.indskr_totalbudget ? this.getFormattedValue(this.planDataSetReference.indskr_totalbudget) : '',
      inputValue: this.planDataSetReference?.indskr_totalbudget,
      id: 'budget-field',
      isDisabled: isDisabled,
      customPlaceholderLabel: isDisabled ? this.translate.instant('NO_BUDGET') : this.translate.instant('ENTER_BUDGET'),
      showArrow: !isDisabled,
      formFieldType: FormFieldType.INLINE_INPUT,
      inputType: 'number',
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    };
    return viewData;
  }

  public getContactFormField(): IndFormFieldViewDataModel {
    let viewData: IndFormFieldViewDataModel;
    viewData = {
      label: this.translate.instant(this.utilityService.globalCustomersText),
      inputText: this.contactsString,
      inputValue: this.contactsString,
      customPlaceholderLabel: !this.isReadOnlyMode ? this.translate.instant('SELECT_WITH_GLOBALCUSTOMER', { globalCustomerText: this.utilityService.globalCustomersText}) : this.translate.instant('No ' + this.utilityService.globalCustomersText),
      id: 'contact-field',
      isReadOnly: true,
      isDisabled: _.isEmpty(this.planDataSetReference.accounts) || (_.isEmpty(this.planDataSetReference.contacts) && this.isReadOnlyMode),
      formFieldType: FormFieldType.NEW_PAGE_SELECT,
      showArrow: !this.isReadOnlyMode,
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    };
    return viewData;
  }

  public getEstimatedRevenueFormField(): IndFormFieldViewDataModel {
    if (this.planDataSetReference) { // when marketing plan is cancelled planDataSetReference will be null
      let viewData: IndFormFieldViewDataModel;
      viewData = {
        label: this.translate.instant('EXPECTED_REVENUE'),
        inputText: this.dateTimeFormatsService.formattedCurrency((this.planDataSetReference.estimatedRevenureFormatted ? this.planDataSetReference.estimatedRevenureFormatted : '0.00')),
        placeholderLabel: '',
        id: 'estimated-revenue-field',
        isReadOnly: true,
        isDisabled: true,
      };
      return viewData;
    }
  }

  public getActualRevenueFormField(): IndFormFieldViewDataModel {
    if (this.planDataSetReference) { // when marketing plan is cancelled planDataSetReference will be null
      let viewData: IndFormFieldViewDataModel;
      viewData = {
        label: this.translate.instant('ACTUAL_REVENUE'),
        inputText: this.dateTimeFormatsService.formattedCurrency((this.planDataSetReference.actualRevenueFormatted ? this.planDataSetReference.actualRevenueFormatted : '0.00')),
        placeholderLabel: '',
        id: 'actual-revenue-field',
        isReadOnly: true,
        isDisabled: true,
      };
      return viewData;
    }
  }

  public getStartPeriodFormField(): IndDateTimeFormViewDataModel {
    let viewData: IndDateTimeFormViewDataModel;
    viewData = {
      isDateField: true,
      label: this.translate.instant('START_DATE'),
      inputText: this.planDataSetReference && this.planDataSetReference.startDate ? this.startPeriod : '',
      customPlaceholderLabel: this.isReadOnlyMode ? '-' : this.translate.instant('SELECT_START_DATE'),
      startDateTimeValue: this.planDataSetReference?.startDate,
      endDateTimeValue: this.planDataSetReference?.endDate,
      fromViewPage: CurViewPageType.AccountPlan,
      id: DateTimeFieldType.StartDateField,
      isReadOnly: true,
      isDisabled: this.isReadOnlyMode,
      showArrow: true,
      isRequired: true,
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    };
    return viewData;
  }

  public getEndPeriodFormField(): IndDateTimeFormViewDataModel {
    let viewData: IndDateTimeFormViewDataModel;
    viewData = {
      isDateField: true,
      label: this.translate.instant('END_DATE'),
      inputText: this.planDataSetReference && this.planDataSetReference.endDate ? this.endPeriod : '',
      customPlaceholderLabel: this.isReadOnlyMode ? '-' : this.translate.instant('SELECT_END_DATE'),
      startDateTimeValue: this.planDataSetReference?.startDate,
      endDateTimeValue: this.planDataSetReference?.endDate,
      id: DateTimeFieldType.EndDateField,
      isReadOnly: true,
      isDisabled: this.device.isOffline || this.isReadOnlyMode,
      showArrow: true,
      isRequired: true,
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    };
    return viewData;
  }

  setShowMore(event) {
    this.showMore = !this.showMore;
  }

  private handleFormFieldEvent(id, event, eventName) {
    // if (this.device.isOffline) return;
    switch (id) {
      case "products-field":
        this.gotoProductSelection();
        break;
      case "contact-field":
        this.gotoContactSelection();
        break;
      case "account-field":
        this.openAccountsSection();
        break;
      case DateTimeFieldType.StartDateField:
        this.openStartDatePicker();
        break;
      case DateTimeFieldType.EndDateField:
        this.openEndDatePicker();
        break;
      case 'name-field':
        if (eventName && eventName == 'input_value_confirm') {
          this.handleMarketingPlanNameUpdate(event);
        }
        break;
      case "budget-field":
        if (eventName && eventName == 'input_value_confirm') {
          this.updatePlannedBudgetField(event);
        }
        break;
      case "currency":
        this.openCurrencySelect(event);
        break;
      default:
        console.log("unhandled case");
    }
  }

  public async openCurrencySelect(event) {
    let options = [];
    if (this.isReadOnlyMode) return;
    const currencies: Currency[] = _.cloneDeep(this.marketingPlansManagementOfflineService.currencies);
    currencies.forEach(({ id, name }: Currency) => {
      let isSelected: boolean = this.planDataSetReference && this.planDataSetReference.currencyId && this.planDataSetReference.currencyId === id;
      options.push({ id, title: name, isSelected: isSelected });
    });
    options = this.marketingPlansManagementOfflineService.sortListByFielName(options, 'title');
    let dropdownListDetail: IndDropdownListDetailModel = {
      id: 'currency-select',
      data: options,
      isMultipleSelectionEnabled: false,
      // isReadOnly: this.isReadOnlyView
    };

    let dropdownPopover = await this.popoverCtrl.create({
      component: IndDropdownListComponent,
      componentProps: {
        viewData: dropdownListDetail
      },
      cssClass: 'dropdown-list-view',
      event: event
    });
    dropdownPopover.onDidDismiss().then(async (obj) => {
      const data = obj.data;
      if (data && data.selectedItems && data.selectedItems.length == 1) {
        if (this.planDataSetReference.currencyId && data.selectedItems[0].id === this.planDataSetReference.currencyId) return;
        const currency: Currency = currencies.find(currency => currency.id === data.selectedItems[0].id);
        await this.uiService.displayLoader();
        await this.marketingPlanManagementDataService.saveMarketPlan({ transactionCurrencyId: currency.id }, this.planDataSetReference.ID);
        this.planDataSetReference.currencyId = currency.id;
        this.planDataSetReference.currencyName = currency.name;
        this.marketingPlanManagementDataService.saveMarketingPlanInLocal(this.planDataSetReference);
        await this.uiService.dismissLoader();
      }
    });
    dropdownPopover.present();
  }

  private handleMarketingPlanNameUpdate(event) {
    if (event && event.target.value !== undefined && event.target.value !== "") {
      this.uiService.displayLoader();
      this.marketingPlanManagementDataService.saveMarketPlan({ indskr_name: event.target.value }, this.planDataSetReference.ID).then(async () => {
        this.planDataSetReference.brandPlanName = event.target.value;
        this.isAutoNameEnabled = false;
        await this.marketingPlanManagementDataService.saveMarketingPlanInLocal(this.planDataSetReference);
        this.marketingPlansManagementOfflineService.marketingPlans$.next(this.marketingPlansManagementOfflineService.marketingPlans);
        this.uiService.dismissLoader();
      });
    }
  }

  private generateMarketPlanName(accounts, products): string {
    let productString = '';
    let accountString = '';

    const numberOfProducts = products.length;
    if (numberOfProducts > 0) {
      productString = ' - ' + products[0].productName + (numberOfProducts > 1 ? ` +${numberOfProducts - 1}` : '');
    }

    const numberOfAccounts = accounts.length;
    if (numberOfAccounts > 0) {
      accountString = ' - ' + accounts[0].name + (numberOfAccounts > 1 ? ` +${numberOfAccounts - 1}` : '');
    }

    const marketPlanName = this.translate.instant('MARKETING_BUSINESS_PLAN') + accountString + productString;
    return marketPlanName;
  }

  private async updatePlannedBudgetField(event) {
    if (event && event.target.value !== undefined && this.planDataSetReference.indskr_totalbudget != event.target.value) {
      this.planDataSetReference.indskr_totalbudget = isNaN(parseInt(event.target.value)) ? null : parseInt(event.target.value);
      this.planDataSetReference.plannedBudgetFormatted = null;
      if (this.planDataSetReference.indskr_totalbudget != null) {
        this.planDataSetReference.plannedBudgetFormatted = this.getFormattedValue(this.planDataSetReference.indskr_totalbudget);
      }
      await this.uiService.displayLoader();
      await this.marketingPlanManagementDataService.saveMarketPlan({ indskr_totalbudget: this.planDataSetReference.indskr_totalbudget }, this.planDataSetReference.ID);
      this.marketingPlanManagementDataService.saveMarketingPlanInLocal(this.planDataSetReference);
      await this.uiService.dismissLoader();
    }
  }

  private getFormattedValue(value: number): string {
    const currency: Currency = this.marketingPlansManagementOfflineService.currencies.find(currency => currency.id === this.planDataSetReference.currencyId);
    if (!currency) return null;
    return this.dateTimeFormatsService.selectedSymbolPos.position == 'left'
      ? currency.symbol + value.toFixed(this.dateTimeFormatsService.selectedDecimalPos.toFixed).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      : value.toFixed(this.dateTimeFormatsService.selectedDecimalPos.toFixed).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + currency.symbol;
  }

  private openAccountsSection() {
    this.accountService.accessedAccountListFrom = PageName.MarketingPlanDetails;
    this.navService.pushWithPageTracking(AccountPageComponent, PageName.AccountPageComponent, {
      'listMode': this.isReadOnlyMode ? ComponentViewMode.READONLY : ComponentViewMode.ADDNEW,
      selectedAccountIds: this.planDataSetReference.accounts,
      callbackEvent: (data: any) => this._handleAccountComponentCallback(data)
    }, PageName.AccountPageComponent).then(() => {
      if (this.planDataSetReference.accounts?.length > 0 && !this.device.isMobileDevice) {
        this.events.publish(EventName.OPEN_SELECTED_ACCOUNT_DETAILS, this.planDataSetReference.accounts[0]);
      }
    });
  }

  private async _handleAccountComponentCallback(selectedAccounts) {
    let reqPayload = {
      accounts: [],
      contacts: [],
      indskr_name: this.planDataSetReference.brandPlanName
    }
    await this.uiService.displayLoader();
    if (!_.isArray(selectedAccounts)) selectedAccounts = [];
    const removedAccounts = this.planDataSetReference.accounts.filter((account) => !_.find(selectedAccounts, account));
    if (removedAccounts.length) {
      reqPayload.contacts = await this.removeAccountAffliated(removedAccounts);
    }

    if (this.isAutoNameEnabled) {
      let newMarketPlanName = this.generateMarketPlanName(selectedAccounts, this.planDataSetReference.products);
      if (newMarketPlanName !== this.planDataSetReference.brandPlanName) {
        reqPayload.indskr_name = newMarketPlanName;
      }
    }

    selectedAccounts.forEach(element => {
      reqPayload.accounts.push({ id: element.id });
    });

    this.planDataSetReference.accounts.filter((item) => !_.find(selectedAccounts, item)).forEach(item => {
      reqPayload.accounts.push({ id: item.id, deleted: true });
    });

    this.marketingPlanManagementDataService.saveMarketPlan(reqPayload, this.planDataSetReference.ID).then(async () => {
      selectedAccounts = _.orderBy(selectedAccounts, 'name');
      this.planDataSetReference.accounts = selectedAccounts;
      this.planDataSetReference.brandPlanName = reqPayload.indskr_name;
      await this.marketingPlanManagementDataService.saveMarketingPlanInLocal(this.planDataSetReference);
      this.accountsString = this.getAccountsString;
      this.marketingPlansManagementOfflineService.marketingPlans$.next(this.marketingPlansManagementOfflineService.marketingPlans);
      this.uiService.dismissLoader();
    });
  }

  async removeAccountAffliated(removedAccounts) {
    if (!this.planDataSetReference.contacts || this.planDataSetReference.contacts.length === 0) return;
    const removeContactIds = [];
    const removeContactPayload = [];
    const removeAccIds = removedAccounts.map(({ id }) => id);
    const contactAccAffs = await this.contactService.getAccountContactAffiliationsFromDB();
    const accountsExceptRemove = this.planDataSetReference.accounts.filter(({ id }) => !removeAccIds.includes(id)).map(({ id }) => id);

    this.planDataSetReference.contacts.forEach(contactAccountAff => {
      const affliation = contactAccAffs.find(item => item['indskr_accountcontactaffiliation.indskr_contactid'] === contactAccountAff.contactId && removeAccIds.includes(item.accountid));
      if (affliation) {
        const otheraffliation = contactAccAffs.find(item => item['indskr_accountcontactaffiliation.indskr_contactid'] === contactAccountAff.contactId && accountsExceptRemove.includes(item.accountid));
        if (otheraffliation) {
          contactAccountAff['indskr_accountcontactaffiliationid'] = otheraffliation['indskr_accountcontactaffiliation.indskr_accountcontactaffiliationid']
        } else {
          removeContactIds.push(contactAccountAff.contactId);
        }
      }
    });

    if (!_.isEmpty(this.planDataSetReference.contacts)) {
      this.planDataSetReference.contacts.filter(contact => removeContactIds.includes(contact.contactId)).map(contact => {
        removeContactPayload.push({ id: contact.contactId, deleted: true });
      });
    }

    this.planDataSetReference.contacts = this.planDataSetReference.contacts.filter((item) => !removeContactIds.includes(item.contactId));
    this.contactsString = this.getContactString;
    return removeContactPayload;
  }

  private gotoContactSelection() {
    if (!this.isReadOnlyMode) {
      if (this.deviceOffline) return;
      this.contactService.contactPageMode = ComponentViewMode.ADDNEW;
    } else {
      this.contactService.contactPageMode = ComponentViewMode.READONLY;
    }
    this.uiService.showNewActivity = false;
    this.contactService.accessedContactListFrom = PageName.MarketingPlanDetails;
    this.navService.pushWithPageTracking(ContactPageComponent, PageName.ContactPageComponent, {
      selectedContactIds: this.planDataSetReference.contacts ? this.planDataSetReference.contacts.map(con => con.contactId) : [],
      selectedAccountIds: this.planDataSetReference.accounts.map(ac => ac.id),
      callbackEvent: (data: any) => this._handleContactComponentCallback(data)
    }, PageName.MarketingPlanDetails, { animate: false }, null);
  }

  private async _handleContactComponentCallback(selectedData: any[]) {
    const reqPayload = [];
    await this.uiService.displayLoader();
    selectedData.forEach(data => reqPayload.push({ id: data['contactId'] }));
    if (!_.isEmpty(this.planDataSetReference.contacts)) {
      this.planDataSetReference.contacts.filter(contact => !selectedData.map(data => data['contactId'])
        .includes(contact.contactId)).map(contact => {
          reqPayload.push({ id: contact.contactId, deleted: true });
        });
    }

    this.marketingPlanManagementDataService.saveMarketPlan({ contacts: reqPayload }, this.planDataSetReference.ID).then(() => {
      selectedData = _.orderBy(selectedData, 'contactFullName');
      this.planDataSetReference.contacts = selectedData;
      this.marketingPlanManagementDataService.saveMarketingPlanInLocal(this.planDataSetReference);
      this.contactsString = this.getContactString;
      this.uiService.dismissLoader();
    });
  }

  private async gotoProductSelection() {
    const selectedProductIds = [];
    if (!_.isEmpty(this.planDataSetReference.products)) {
      this.planDataSetReference.products.map(prod => selectedProductIds.push(prod.productID));
    }

    // products
    let options: SelectListData[] = this.brandService.brands.map(({ ID, name }) => {
      return {
        id: ID,
        title: name,
        isSelected: selectedProductIds.includes(ID)
      }
    });

    // product bundle
    if (this.surgeryOrderActivityDataService.procedureTrackerProductHierarchies.length > 0) {
      this.surgeryOrderActivityDataService.procedureTrackerProductHierarchies.forEach(({ surgeryId, surgeryName }) => {
        options.push({ id: surgeryId, title: surgeryName, isSelected: selectedProductIds.includes(surgeryId) })
      })
    }

    // to populate unmapped products
    selectedProductIds.forEach((productid) => {
      if (options.every((option) => option.id !== productid)) {
        let product = this.planDataSetReference.products.find((pro) => pro.productID === productid)
        options.push({ id: productid, title: product.productName, isSelected: selectedProductIds.includes(productid) })
      }
    });

    options = _.orderBy(_.uniqBy(options, 'id'), 'title');
    const productsModal = await this.modalCtrl.create({
      component: SelectListComponent,
      componentProps: {
        viewData: {
          data: options,
          isReadOnly: this.isReadOnlyMode,
          isMultipleSelectionEnabled: true,
          title: this.translate.instant('PRODUCTS'),
          dividerTitle: this.translate.instant('ALL_PRODUCTS_CAP'),
          isSearchEnabled: true,
        }
      },
      backdropDismiss: false
    });
    productsModal.present();
    productsModal.onDidDismiss().then(async (obj: any) => {
      const data = obj.data;
      if (data && data.isDone) {
        const reqPayload: any = {
          products: [],
          indskr_name: this.planDataSetReference.brandPlanName
        };
        let productsRef = [];
        data.selectedItems.forEach(selectedItem => {
          reqPayload.products.push({ id: selectedItem.id });
          productsRef.push({ productID: selectedItem.id, productName: selectedItem.title });
        });

        if (!_.isEmpty(this.planDataSetReference.products)) {
          this.planDataSetReference.products.filter(prod => !data.selectedItems.map(selectedItem => selectedItem.id)
            .includes(prod.productID)).forEach(prod => reqPayload.products.push({ id: prod.productID, deleted : true }));
        }

        if (this.isAutoNameEnabled) {
          let newMarketPlanName = this.generateMarketPlanName(this.planDataSetReference.accounts, productsRef);
          if (newMarketPlanName !== this.planDataSetReference.brandPlanName) {
            reqPayload.indskr_name = newMarketPlanName;
          }
        }

        await this.uiService.displayLoader();
        await this.marketingPlanManagementDataService.saveMarketPlan(reqPayload, this.planDataSetReference.ID).then(async (newMarketPlan) => {
          productsRef = _.orderBy(productsRef, 'productName');
          this.planDataSetReference.products = productsRef;
          this.planDataSetReference.brandPlanName = reqPayload.indskr_name;
          this.productsString = this.getProductsString;
          await this.marketingPlanManagementDataService.saveMarketingPlanInLocal(this.planDataSetReference);
          this.marketingPlansManagementOfflineService.marketingPlans$.next(this.marketingPlansManagementOfflineService.marketingPlans);
          this.uiService.dismissLoader();
        });
      }
    })
  }

  onSectionHeaderControlClick(id: string) {
    switch (id) {
      case 'add-marketing-plan-events':
        this.openEvents();
        break;
      case "attach":
        this.handleNoteAttachment();
        break;
      case "save-notes":
        this.handleNotesSave();
        break;
      case 'add-opportunities':
        this.openOpportunities();
        break;
      default:
        console.error("unhandled error");
    }
  }

  private openOpportunities() {
    // const accountIds = this.data.accounts.map(el => el.id);
    // const opportunitiesDataSet = this.opportunityService.opportunities.filter(item => item.status == "Open");
    const opportuntiesSelectionViewData: OpportunitySelectionViewDataModel = {
      isReadOnlyMode: false,
      opportunitiesDataSet: this.opportunityService.opportunities,
      selectedOpportunities: this.associatedOpportunities,
      disableDoneButtonInOffline: false,
      callbackFromSelectionComponent: (event: string, newSelectedOpportunities: Array<Opportunity>, data: any) => this._handledOpportunitiesSelection(event, newSelectedOpportunities, data),
    };
    this.navService.pushWithPageTracking(OpportunitySelectionPageComponent, PageName.OpportunitySelectionPage, { viewData: opportuntiesSelectionViewData }, PageName.OpportunitySelectionPage);
  }

  private async _handledOpportunitiesSelection(event, newSelectedOpportunities: Array<Opportunity>, data: any) {
    if (event && event == 'DONEBUTTONCLICK') {
      let opportuntiesPayload = [];
      if (_.isEmpty(this.associatedOpportunities) && !_.isEmpty(newSelectedOpportunities)) {
        opportuntiesPayload = newSelectedOpportunities.map(opp => {
          return {
            id: opp.ID
          }
        });
      } else if (!_.isEmpty(this.associatedOpportunities) && _.isEmpty(newSelectedOpportunities)) {
        opportuntiesPayload = this.associatedOpportunities.map(opp => {
          return {
            id: opp.ID,
            deleted: true
          }
        });
      } else {
        this.associatedOpportunities.forEach(opp => {
          if (newSelectedOpportunities.findIndex(newOpp => newOpp.ID === opp.ID) == -1) {
            opportuntiesPayload.push({
              id: opp.ID,
              deleted: true
            })
          }
        })
        newSelectedOpportunities.forEach(opp => {
          if (this.associatedOpportunities.findIndex(newOpp => newOpp.ID === opp.ID) == -1) {
            opportuntiesPayload.push({
              id: opp.ID
            })
          }
        })
      }
      const accountsToAutoMapPayload = [];
      let accountsToAutoMap = [];
      opportuntiesPayload.filter(op => !op.deleted).forEach(opp => {
        const foundOpportunity = this.opportunityService.getOpportunityDetailsbyId(opp.id);
        if (foundOpportunity && !this.planDataSetReference.accounts.map(acc => acc.id).includes(foundOpportunity.accountID) && !accountsToAutoMapPayload.map(acc => acc.id).includes(foundOpportunity.accountID)) {
          accountsToAutoMapPayload.push({ id: foundOpportunity.accountID });
          accountsToAutoMap.push({ id: foundOpportunity.accountID, name: foundOpportunity.accountName, statecode: 1 });
        }
      });
      const payload = { opportunities: opportuntiesPayload, accounts: accountsToAutoMapPayload };
      accountsToAutoMap.push(...this.planDataSetReference.accounts);
      accountsToAutoMap = _.orderBy(accountsToAutoMap, 'name');
      if (this.isAutoNameEnabled) {
        const newMarketPlanName = this.generateMarketPlanName(accountsToAutoMap, this.planDataSetReference.products);
        if (newMarketPlanName !== this.planDataSetReference.brandPlanName) {
          payload['indskr_name'] = newMarketPlanName;
        }
      }
      await this.uiService.displayLoader();
      await this.marketingPlanManagementDataService.saveMarketPlan(payload, this.planDataSetReference.ID);
      opportuntiesPayload.forEach(opp => {
        const index = this.associatedOpportunities.findIndex(aOpp => aOpp.ID === opp.id);
        if (opp.deleted) {
          this.associatedOpportunities.splice(index, 1);
        } else {
          const foundOpportunity = this.opportunityService.getOpportunityDetailsbyId(opp.id);
          if (foundOpportunity && index == -1) {
            this.associatedOpportunities.push(foundOpportunity);
          }
        }
      });
      this.planDataSetReference.accounts = accountsToAutoMap;
      this.accountsString = this.getAccountsString;
      if (payload['indskr_name'])
        this.planDataSetReference.brandPlanName = payload['indskr_name'];
      this.associatedOpportunities = _.orderBy(this.associatedOpportunities, 'opportunityName');
      this.planDataSetReference.opportunities = this.associatedOpportunities;
      this.marketingPlanManagementDataService.saveMarketingPlanInLocal(this.planDataSetReference);
      this.marketingPlansManagementOfflineService.selectedMarketingPlan$.next(this.planDataSetReference);
      this.marketingPlansManagementOfflineService.marketingPlans$.next(this.marketingPlansManagementOfflineService.marketingPlans);
      await this.uiService.dismissLoader();
    }
  }

  private handleNoteAttachment() {
    try {
      this.attachInput.nativeElement.click();
    } catch (error) {
      console.log(error);
    }
  }

  private async handleNotesSave() {
    if (this.isSaveNotesEnabled && ((this.notes && !_.isEmpty(this.notes)) || !_.isEmpty(this.base64str))) {
      this.isSaveNotesEnabled = false;
      this.initializeNotesHeader();
      this.uiService.displayLoader();
      let tempNote: any = {
        annotationid: Guid.create().toString(),
        createdon: new Date().getTime(),
        notetext: this.notes,
        ownerName: this.authService.user.displayName,
        ownerid: this.authService.user.systemUserID,
      };
      if (this.base64str) {
        tempNote['isdocument'] = true;
        tempNote['documentbody'] = this.base64str;
        tempNote['filename'] = this.attachmentFile.name;
        tempNote['mimetype'] = this.attachmentFile.type;
      } else {
        tempNote['hasDocument'] = false;
      }
      if (!this.planDataSetReference.MarketingPlansNotes) {
        this.planDataSetReference.MarketingPlansNotes = [];
      }

      const response: any = await this.marketingPlanManagementDataService.saveAttachments([tempNote], this.planDataSetReference.ID);
      tempNote.annotationid = response.noteid;
      tempNote = new IONote(tempNote);
      this.planDataSetReference.MarketingPlansNotes.push(tempNote);
      this.planDataSetReference.MarketingPlansNotes.sort((a, b) => {
        return (isBefore(a.createdTime, b.createdTime) ? 1 : -1)
      })
      this.brandnotes = this.planDataSetReference.MarketingPlansNotes;
      // this.planDataSetReference.MarketingPlansNotes = this.data.MarketingPlansNotes;
      await this.marketingPlanManagementDataService.saveMarketingPlanInLocal(this.planDataSetReference);
      this.removeAttachment(null);
      this.notes = '';
      // this.updateSaveBtn();
      this._sortNotes();
      this.uiService.dismissLoader();
    }
  }

  get nonDeletedNotes() {
    return this.planDataSetReference?.MarketingPlansNotes?.filter(note => !note.isDeleted)
  }

  private _sortNotes(): void {
    if (this.planDataSetReference.MarketingPlansNotes && this.planDataSetReference.MarketingPlansNotes.length > 1) {
      this.planDataSetReference.MarketingPlansNotes.sort((a, b) => {
        return (isBefore(a.createdTime, b.createdTime) ? 1 : -1)
      })
    }
  }

  public removeAttachment(event) {
    try {
      this.attachInput.nativeElement.value = null;
    } catch (error) {
      console.log(error);
    }
    this.attachmentTitle = '';
    this.isAttachmentAdded = false;
    this.attachmentFile = null;
    this.base64str = null;
  }

  public async updateNote(ev) {
    if (ev && ev.action) {
      if (this.device.isOffline) return;
      const idx = this.planDataSetReference.MarketingPlansNotes.findIndex(note => note.noteId === ev.noteId);
      let note = this.planDataSetReference.MarketingPlansNotes[idx];

      if (ev.action === 'DELETE' && idx >= 0) {
        note.isDeleted = true;
        if (note.hasDocument)
          note = this._resetDocumentDetailsOfNote(note);
      } else if (ev.action === 'SAVE' && idx >= 0) {
        note.noteText = ev.updatedText;
        if (ev.attachmentFileUpdated) {
          note = this._updateAttachmentinNotes(note, ev);
        }
        //  else if (ev.attachmentFileUpdated) {
        // note = this._updateAttachmentinNotes(note, ev)
        // } 
        else if (ev.isAttachmentRemoved) {
          note.hasDocument = false;
          note = this._resetDocumentDetailsOfNote(note);
        }
      }

      let payload: any = { ...note, notetext: note.noteText, noteid: note.noteId }
      if (ev.action === 'DELETE' && idx >= 0) {
        payload = { ...payload, deleted: true }
      }

      if (note.hasDocument) {
        payload = {
          ...payload,
          isdocument: true,
          documentbody: ev.attachmentFileDataUrl,
          filename: ev.documentName,
          mimetype: ev.documentMimeType
        }
      }

      if (ev.isAttachmentRemoved) {
        payload = {
          ...payload,
          isdocument: false,
          documentbody: '',
          filename: '',
          mimetype: ''
        }
      }

      await this.uiService.displayLoader();
      await this.marketingPlanManagementDataService.saveAttachments([payload], this.planDataSetReference.ID);
      if (ev.action === 'DELETE' && idx >= 0) {
        this.planDataSetReference.MarketingPlansNotes.splice(idx, 1);
      } else {
        this.planDataSetReference.MarketingPlansNotes[idx] = note;
      }
      this.brandnotes = this.planDataSetReference.MarketingPlansNotes;
      await this.marketingPlanManagementDataService.saveMarketingPlanInLocal(this.planDataSetReference);
      this.removeAttachment(null);
      this.notes = '';
      // this.updateSaveBtn();
      this._sortNotes();
      this.uiService.dismissLoader();
    }
  }

  private _resetDocumentDetailsOfNote(note: IONote) {
    note.documentSize = 0;
    note.documentName = '';
    note.documentMimeType = '';
    note.documentDataURL = '';
    note.hasDocument = false;
    return note;
  }

  private _updateAttachmentinNotes(note: any, ev: any) {
    note.hasDocument = true;
    note.documentSize = ev.documentSize;
    note.documentName = ev.documentName;
    note.documentMimeType = ev.documentMimeType;
    note.documentDataURL = ev.attachmentFileDataUrl;
    return note;
  }

  public async loadImageFromDevice(event) {
    if (event && event.target && event.target.files) {
      try {
        if ((event.target.files[0].size / 1000) < MAXIMUM_NOTE_ATTACHMENT_SIZE) {
          if (NOTE_ATTACHMENT_MIME_TYPES_SUPPORTED_REGEX.test(event.target.files[0].name)) {
            this.attachmentFile = event.target.files[0];
            this.attachmentTitle = event.target.files[0].name;
            this.isAttachmentAdded = true;
            this.base64str = await toBase64(this.attachmentFile);
            this.isSaveNotesEnabled = true;
            this.initializeNotesHeader();
          } else {
            this.notificationService.notify(this.translate.instant('NOTE_ATTACHMENT_MIME_TYPE_NOT_SUPPORTED_NOTIFICATION'), 'Note Attachment', 'top', 'info');
            this.removeAttachment(false);
          }
        } else {
          this.notificationService.notify(this.translate.instant('MAXIMUM_NOTE_ATTACHMENT_SIZE_NOTIFICATION', { size: MAXIMUM_NOTE_ATTACHMENT_SIZE }), 'Note Attachment', 'top', 'info');
          this.removeAttachment(false);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  public notesChanged(ev): void {
    if (this.device.isOffline) return;
    if (ev && ev.target) {
      this.notes = ev.target.value;
      this.isSaveNotesEnabled = true;

    } else {
      this.notes = '';
      this.isSaveNotesEnabled = true;

    }
    this.initializeNotesHeader();
  }

  private openEvents() {
    const eventsSelectionViewData: EventsSelectionViewDataModel = {
      isReadOnlyMode: false,
      eventsDataSet: [],
      selectedEvents: this.associatedEvents,
      disableDoneButtonInOffline: true,
      viewMode: ComponentViewMode.ADDNEW,
      callbackFromSelectionComponent: (event: string, newSelectedEvents: Array<EventActivity>, data: any) => this._handledEventsSelection(event, newSelectedEvents, data),
    };
    const startDate = this.planDataSetReference.startDate, endDate = this.planDataSetReference.endDate;

    this.navService.pushWithPageTracking(EventsToolPageComponent, PageName.EventsToolPageComponent, { viewData: eventsSelectionViewData, startDate, endDate, from: 'brand-plan' }, PageName.EventsToolPageComponent);
  }

  private async _handledEventsSelection(ev, newSelectedEvents: Array<EventActivity>, data: any) {
    if (ev && ev == 'DONEBUTTONCLICK') {
      let eventsPayload = [];
      if (_.isEmpty(this.associatedEvents) && !_.isEmpty(newSelectedEvents)) {
        eventsPayload = newSelectedEvents.map(opp => {
          return {
            id: opp.ID
          }
        });
      } else if (!_.isEmpty(this.associatedEvents) && _.isEmpty(newSelectedEvents)) {
        eventsPayload = this.associatedEvents.map(opp => {
          return {
            id: opp.ID,
            deleted: true
          }
        });
      } else {
        this.associatedEvents.forEach(opp => {
          if (newSelectedEvents.findIndex(newOpp => newOpp.ID === opp.ID) == -1) {
            eventsPayload.push({
              id: opp.ID,
              deleted: true
            })
          }
        })
        newSelectedEvents.forEach(opp => {
          if (this.associatedEvents.findIndex(newOpp => newOpp.ID === opp.ID) == -1) {
            eventsPayload.push({
              id: opp.ID
            })
          }
        })
      }
      await this.uiService.displayLoader();
      await this.marketingPlanManagementDataService.saveMarketPlan({ events: eventsPayload }, this.planDataSetReference.ID);
      eventsPayload.forEach(event => {
        const index = this.associatedEvents.findIndex(aOpp => aOpp.ID === event.id);
        if (event.deleted) {
          this.associatedEvents.splice(index, 1);
        } else {
          const foundEvent = this.eventToolService.getEventDetailsbyId(event.id);
          if (foundEvent && index == -1) {
            this.associatedEvents.push(foundEvent);
          }
        }
      });
      this.associatedEvents = _.orderBy(this.associatedEvents, 'name');
      this.planDataSetReference.events = this.associatedEvents;
      this.marketingPlanManagementDataService.saveMarketingPlanInLocal(this.planDataSetReference);
      await this.uiService.dismissLoader();
    }
  }

  onTextAreaFocus(value) {
    if (this.deviceOffline) return;
  }

  private async openStartDatePicker() {
    this.activityService.dateTimePickerType = DateTimeFieldType.StartDateField;
    let popover = await this.getDateTimePopover();
    popover.present();
    popover.onDidDismiss().then(async (obj: any) => {
      if (obj && obj.data && !_.isEmpty(obj.data.startTime)) {
        const valueDate = new Date(obj.data.startTime).getTime();
        if (this.planDataSetReference.endDate && valueDate > parseInt(this.planDataSetReference.endDate)) {
          this.notificationService.notify(this.translate.instant('AFFILIATION_END_DATE_CAN_NOT_BEFORE_START_DATE'), this.translate.instant('MARKETING_BUSINESS_PLAN'), 'top', ToastStyle.DANGER);
        } else {
          await this.uiService.displayLoader();
          if (await this.isActivityInPast(obj.data.startTime)) {
            this.uiService.dismissLoader();
            this.notificationService.notify(this.translate.instant('MARKETING__BUSINESS_PLAN_ACTIVITY_VALIDATION'), 'Marketing business Plan', 'top', ToastStyle.DANGER);
            return;
          }
          this.marketingPlanManagementDataService.saveMarketPlan({ indskr_validfrom: valueDate }, this.planDataSetReference.ID).then(() => {
            this.planDataSetReference.startDate = valueDate.toString();
            this.marketingPlanManagementDataService.saveMarketingPlanInLocal(this.planDataSetReference);
            this.uiService.dismissLoader();
          });

        }
      }
    })
  }

  private async openEndDatePicker() {
    if (!this.planDataSetReference.startDate) return;
    const today = new Date().getTime();
    this.activityService.dateTimePickerType = DateTimeFieldType.EndDateField;
    let popover = await this.getDateTimePopover();
    popover.present();
    popover.onDidDismiss().then(async (obj: any) => {
      if (obj && obj.data && !_.isEmpty(obj.data.endTime)) {
        const valueDate = new Date(obj.data.endTime).getTime();
        if (parseInt(this.planDataSetReference.startDate) > valueDate) {
          this.notificationService.notify(this.translate.instant('AFFILIATION_END_DATE_CAN_NOT_BEFORE_START_DATE'), this.translate.instant('MARKETING_BUSINESS_PLAN'), 'top', ToastStyle.DANGER);
        } else if (valueDate < today) {
          this.notificationService.notify(this.translate.instant('MARKETING_BUSINESS_PLAN_CAN_NOT_BE_PAST'), this.translate.instant('MARKETING_BUSINESS_PLAN'), 'top', ToastStyle.DANGER);
        } else {
          if (this.isSameDateWithoutTime(new Date(obj.data.endTime), new Date(parseInt(this.planDataSetReference.endDate)))) return;
          await this.uiService.displayLoader();
          this.marketingPlanManagementDataService.saveMarketPlan({ indskr_validto: valueDate }, this.planDataSetReference.ID).then(() => {
            this.planDataSetReference.endDate = valueDate.toString();
            this.marketingPlanManagementDataService.saveMarketingPlanInLocal(this.planDataSetReference);
            this.uiService.dismissLoader();
          });
        }
      }
    })
  }

  isSameDateWithoutTime(firstDate: Date, secondDate: Date) {
    return firstDate.setHours(0, 0, 0, 0) === secondDate.setHours(0, 0, 0, 0);
  }

  private async getDateTimePopover() {
    return await this.popoverCtrl.create({
      component: IndDatetimeFormComponent,
      componentProps: {
        currentViewPage: CurViewPageType.MarketingBusinessPlan,
        startDateTimeValue: this.planDataSetReference?.startDate ? moment(new Date(parseInt(this.planDataSetReference.startDate))).format() : null,
        endDateTimeValue: this.planDataSetReference?.endDate ? moment(new Date(parseInt(this.planDataSetReference.endDate))).format() : null,
      },
      cssClass: "datetime-popover"
    });
  }

  private async isActivityInPast(newStartDate) {
    const allActivities = await this.getActivitiesByAccountPlan();
    const activityFollowup = this.marketingPlanManagementDataService.getFollowupActivity(this.planDataSetReference);
    const linkedMeeting = await this.marketingPlanManagementDataService.fetchMeetingsTimeline(this.planDataSetReference.ID);
    const linkedTimeline = await this.marketingPlanManagementDataService.fetchPhoneCallsTimeline(this.planDataSetReference.ID);

    console.log(linkedMeeting, linkedTimeline);


    allActivities.push(...activityFollowup)
    allActivities.push(...linkedMeeting)
    allActivities.push(...linkedTimeline)

    const isConflict = allActivities.some(actvity => {
      actvity.scheduledStart.setHours(0, 0, 0, 0);
      return actvity.scheduledStart < new Date(newStartDate).setHours(0, 0, 0, 0);
    });

    return isConflict;
  }

  private async getActivitiesByAccountPlan() {
    let allActivities = [];
    // allActivities = this.activityService.activities.filter((item: any) => {
    //   if (item.type === ActivityType.Appointment) {
    // //     return item.associatedAccountPlans.some((it) => it.accountPlanId === this.planDataSetReference.ID);
    // //   } else if (item.type === ActivityType.PhoneCall) {
    // //     return item.accountPlanId === this.planDataSetReference.ID;
    // //   } else if (item.type === ActivityType.FollowUp) {
    // //     return item.accountPlanId === this.planDataSetReference.ID;
    //   }
    // });
    return allActivities;
  }

  ngOnDestroy() {
    this.ngUnSubscibe$.next(true);
    this.ngUnSubscibe$.complete();
  }

}
